export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20a%20digital%20resource%20library%20with%20floating%20file%20cards%2C%20download%20clouds%20and%20circuit%20waves%2C%20warm%20terracotta%20orange%2C%20cream%20and%20deep%20pine%20green%20color%20palette%2C%20layered%20geometric%20paper-cut%20style%2C%20soft%20gradient%20lighting%2C%20no%20text&width=1600&height=900&seq=hero-zhai-main&orientation=landscape"
          alt="宅宅资源库首屏背景图"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/55"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-28 text-center md:px-6 md:py-36">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/30 backdrop-blur">
          <i className="ri-flashlight-line text-accent-300"></i>
          网盘 · 直链 · 磁力 · 秒传，一站搞定
        </span>

        <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          宅宅资源库
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          集中汇总网盘、直链、磁力、秒传多种获取方式。不用挨个帖子试失效链接，
          按格式筛选即可快速定位可用资源，热门资源提供打包下载，追更补档更省心。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <button
            onClick={() => document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" })}
            className="flex h-12 w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-7 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-download-2-line text-lg"></i>
            开始查找资源
          </button>
          <button
            onClick={() => document.getElementById("guide")?.scrollIntoView({ behavior: "smooth" })}
            className="flex h-12 w-full items-center justify-center gap-2 rounded-md bg-background-50/15 px-7 text-sm font-medium whitespace-nowrap text-background-50 ring-1 ring-background-50/40 backdrop-blur transition-colors hover:bg-background-50/25 sm:w-auto"
          >
            查看使用指南
          </button>
        </div>

        <dl className="mt-12 grid w-full grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: "1200+", label: "累计收录资源" },
            { num: "4 种", label: "获取方式" },
            { num: "8 大", label: "内容分类" },
            { num: "日更", label: "追更补档" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50/10 px-4 py-4 ring-1 ring-background-50/20 backdrop-blur"
            >
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-2xl font-bold text-accent-300">{s.num}</dd>
              <dd className="mt-1 text-xs text-background-50/80">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}